/*
 * INFO:
 * 	> Main script initializer
 */

var app = {
	//Configs + Constants

	//removeIf(production)
	debug: true,
	debugLocalIps: ['localhost', '192.168.6.141'],
	envs: {
		dev: '',
		stage: ''
	},
	//endRemoveIf(production)

	assetsURI: '/',

	mobileWidth: '768',
	loadedFonts: 0,
	loadedImages: 0,
	lang: $('body').data('lang'),
	host: window.location.hostname,
	browser: false,
	navigator: '',

	SIZE: {
		wW: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
		wH: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
	},

	API: {
		baseURI: '',
		contact: '/api/contacts/add',
		newsletter: '/api/newsletter/add'
	},

	DATA: {},

	COOKIES_NAMES: {
		ACCEPT: 'acceptCookie'
	},

	exists: function (el) {
		return ($(el).length > 0);
	},

	isMobile: function () {
		return (app.SIZE.wW <= app.mobileWidth);
	},

	//removeIf(production)
	debugEnvir: function () {
		return (app.debug && app.host !== undefined && app.debugLocalIps.length > 0 && app.debugLocalIps.indexOf(app.host) > -1);
	},
	//endRemoveIf(production)

	init: function () {
		// GLOBAL VARS ---------------------------------------
		$doc = $(document);
		$body = $doc.find('body');

		//ON RESIZE
		$(window).resize(function () {
			app.SIZE.wW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			app.SIZE.wH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		});

		//removeIf(production)
		if(!app.helpers.isEmpty(window.location.port) && window.location.port <= 9999){
			app.API.baseURI = app.envs.dev;
		}
		//endRemoveIf(production)


		/* COMPONENTS ----------------------------------------
            > Animations
                - Canvas lines
                - Chapter IN / OUT

            > Social Share
            > Tooltips
            > Modals
            > Forms
            > Cookies
            > Downloads PDF
         */

		app.components.init();

		app.header.init();
		app.content.init();
		app.modSliders.init();

		outdatedBrowser({
			bgColor: '#f25648',
			color: '#ffffff',
			lowerThan: 'transform'
		});

		if (window.cookieconsent) {
			cookieconsent.initialise({
				"palette": {
					"popup": {
						"background": "#ffffff"
					},
					"button": {
						"background": "#fff",
						"text": "#3e3e3e"
					}
				},
				"cookie": {
					"name": "cookieconsent_status",
					"expiryDays": 30,
				},
				"theme": "edgeless",
				"position": "bottom-right",
				"content": {
					"message": dynamic.privacyText,
					"dismiss": "&#10005;",
					"link": 'Saber mais',
					"href": dynamic.privacyLink
				}
			});
		}
	}
};

var $doc, $body, $main, AJAXCALL;
(function ($) {
	'use strict';
	$(document).ready(function () {
		app.init();

	});
})(jQuery);
